// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingMask_root__3gwYx","loadingText":"LoadingMask_loadingText__2dYVX"};